import React from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { msalInstance } from '../src/common/security/authConfig';
import { MsalProvider } from '@azure/msal-react';

function App() {

  return (
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <div className='App'>
          <div className='page-wrapper'>
            <Layout  />
          </div>
        </div>
      </MsalProvider>
    </BrowserRouter>
  );
}

export default App;
